import { render, staticRenderFns } from "./ChartGrowth.vue?vue&type=template&id=bd0785b2&"
import script from "./ChartGrowth.vue?vue&type=script&lang=js&"
export * from "./ChartGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports